import React from 'react';
import { Colors } from '../colors/colors';
import { ReactComponent as Clone } from '../icons/clone.svg';
import { ReactComponent as Trash } from '../icons/trash.svg';
import { ReactComponent as Edit } from '../icons/edit.svg';

const icons = {
	clone: Clone,
	trash: Trash,
	edit: Edit,
};

const Icon = ({
	name,
	size = 16,
	color = Colors.darkBlue,
	cursor = 'pointer',
	onClick = () => { },
	rotate,
	style = {},
}) => {

	const SvgIcon = icons[name];

	const basicStyle = {
		transform: rotate ? 'rotate(180deg)' : '',
		color: color,
		fontWeight: 'bold',
		cursor: cursor,
		fontSize: `${size}px`,
		transition: '0.3s all',
		...style,
	}

	if (SvgIcon) {
		return <SvgIcon width={size} height={size} style={{ ...basicStyle, ...style }} onClick={() => onClick()} />;
	}

	return (
		<i
			className={name}
			style={{
				...basicStyle,
				...style,
			}}
			onClick={() => onClick()}
		/>
	);
};

export default Icon;
